module.exports = __webpack_public_path__ + "amazonpay-badge.7003d069e6e987eba6c3c03e170a59e2.svg";